export default class ElementHandler {
    /**
     * 指定した要素の子要素から、指定したクラス名を持つ要素を探し、そのクラス名を削除します。
     * @param parent 探索対象の親要素
     * @param className 削除するクラス名
     */
    removeClassFromDescendants(parent, className) {
        const descendants = parent.querySelectorAll(`.${className}`);
        this.removeClassFromElements(descendants, className);
    }
    /**
     * 指定した要素にクラス名を追加します。
     * @param elements クラス名を追加する要素
     * @param className 追加するクラス名
     */
    addClassToElements(elements, className) {
        elements.forEach(elm => elm.classList.add(className));
    }
    /**
     * 指定した要素からクラス名を削除します。
     * @param elements クラス名を削除する要素
     * @param className 削除するクラス名
     */
    removeClassFromElements(elements, className) {
        elements.forEach(elm => elm.classList.remove(className));
    }
    /**
     * 指定した要素までスクロールします。
     * @param element スクロール先の要素
     * @param options スクロールオプション
     */
    scrollToElement(element, options = null) {
        if (!element)
            return;
        element.scrollIntoView(options ?? { behavior: "smooth", block: "center" });
    }
    /**
     * 指定した要素を非表示にします。
     * @param elements 非表示にする要素
     */
    hideElements(elements) {
        elements.forEach(elm => elm.style.display = 'none');
    }
    /**
     * 指定した要素をアクティブにし、他の要素を非アクティブにします。
     * @param element アクティブにする要素
     * @param parent 非アクティブにする要素の親要素
     * @param activeClassName 設定するアクティブクラス名 (文字列または文字列の配列)
     */
    setElementAsActiveAndDeactivateOthers(element, parent, activeClassName) {
        if (!element)
            return;
        if (Array.isArray(activeClassName)) {
            activeClassName.forEach(className => this.setElementAsActiveAndDeactivateOthers(element, parent, className));
        }
        else {
            this.removeClassFromDescendants(parent, activeClassName);
            element.classList.add(activeClassName);
        }
    }
}
